import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class MessagesProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(options: { practiceId?: string; maxNbItems?: number }): Promise<MessageSummaryDTO[]> {
        const url = this.configurationService.APIURL + '/api/messages';
        let params = new HttpParams();
        if (options.practiceId) {
            params = params.append('practiceId', String(options.practiceId));
        }
        if (options.maxNbItems) {
            params = params.append('maxNbItems', String(options.maxNbItems));
        }
        return await this.http.get<MessageSummaryDTO[]>(url, { params: params }).toPromise();
    }

    async create(createOrUpdateMessageDTO: CreateOrUpdateMessageDTO) {
        const url = this.configurationService.APIURL + '/api/messages';
        await this.http.post(url, createOrUpdateMessageDTO).toPromise();
    }

    async update(messageId: string, createOrUpdateMessageDTO: CreateOrUpdateMessageDTO) {
        const url = this.configurationService.APIURL + '/api/messages/' + messageId;
        await this.http.put(url, createOrUpdateMessageDTO).toPromise();
    }

    async delete(messageId: string) {
        const url = this.configurationService.APIURL + '/api/messages/' + messageId;
        await this.http.delete(url).toPromise();
    }
}

export interface MessageSummaryDTO {
    id: string;
    createdBy: string;
    createdOn: Date | string;
    header: string;
    body: string;
    from: string;
    hyperLink: string;
}

export interface CreateOrUpdateMessageDTO {
    header: string;
    body: string;
    from: string;
    hyperLink: string;
}
